export default __webpack_public_path__ + "static/media/new_row.28ba9909.svg";